app.ui.addFeature(
	'dataEntry',
	function(){
		'use strict';

		var self = this;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the component
		*/
		self.init = function(){

		};

		self.constructWatcherIDString = function(field) {
			return "fieldValues." + field.properties.id;
		};

		self.constructSubFormWatcherIDString = function(field, subForm) {
			return 'subForms.' + subForm.id + "." + self.constructWatcherIDString(field);
		};

		self.applyLiveFieldCalculationEvents = function(field, renderedFormControl) {
			if (renderedFormControl && field && field.type === "calculation") {
				app.ui.liveFieldCalculation(field, renderedFormControl.formConfig.fields);
			}
		};

		self.addFieldEvents = function(field, formFields, renderedFormControl) {
			if (field) {
				if(Array.isArray(field.logic)){
					//form
					field.args = {
						logic: field.logic
					};
					app.ui.logic.fieldLevel(field, formFields, renderedFormControl.vueData, "ui.");
				}
				app.events.emit.After(500,
					[
						'ui.' + field.properties.id,
						{
							id : field.properties.id,
							newValue : "",
							oldValue : "",
							type: "ON_INIT"
						}
					],
					app.events
				);
			}
		};

		self.addFieldEventEmitterFunc = function(field, renderedFormControl, watcherIDString) {
			var _fn = function(newValue,oldValue) {
				app.events.emit(
					"formValuesChanged",
					{
						id : field.properties.id,
						newValue : newValue,
						oldValue : oldValue
					}
				);
				app.events.emit(
					'ui.' + field.properties.id,
					{
						id : field.properties.id,
						newValue : newValue,
						oldValue : oldValue
					}
				);
			};
			if(typeof renderedFormControl.vueWatchers[watcherIDString] === 'function'){
				var _fn2 = renderedFormControl.vueWatchers[watcherIDString];
				renderedFormControl.vueWatchers[watcherIDString] = function(newValue,oldValue){
					_fn2();
					_fn(newValue, oldValue);
				};
			}
			else {
				renderedFormControl.vueWatchers[watcherIDString] = _fn;
			}

			self.applyLiveFieldCalculationEvents(field, renderedFormControl);
		};

		/*
			Name: renderForm
			Use: API.renderForm()
			Args: formConfig Object - Configuration object defining data-entry fields and settings
			Description: Renders a data entry form
		*/
		self.renderForm = function(formConfig, pageConfig, jurisdiction){
			var renderedFormControl = {
					formConfig : formConfig,
					pageConfig : pageConfig,
					htmlTemplate : '',
					compiledHtml : '',
					dataEntryApp : {},
					vueData : {
						fieldValues : {},
						subForms : {},
						editIdx : -1,
						isProcessing : false
					},
					vueWatchers : {

					}
				},
				def = app.deferred(),
				listenersToApply = [];

				def.step(
					function(){
						app.templates.get(renderedFormControl.formConfig.template).finished(def.next);
					}
				);

				def.step(
					function(res){
						renderedFormControl.formConfig = JSON.clone(renderedFormControl.formConfig);

						if(document.location.href.indexOf('/virginia') !== -1){
							var idxAt = -1;
							formConfig.fields.forEach(
								function(fld, idx){
									if(fld.properties.id === 'OwnerBuildingNumber'){
										idxAt = idx;
									}
								}
							);

							if(idxAt !== -1){
								renderedFormControl.formConfig.fields.splice(
									idxAt,
									0,
									{
										type : 'select',
										options : [
											{
												text : 'Yes',
												value : 'YES'
											},
											{
												text : 'No',
												value : 'NO'
											}
										],
										properties : {
											id : 'doCopySystemInfoToOwner',
											label : 'Same as System Info?'
										}
									}
								);
								app.events.on(
									'ui.doCopySystemInfoToOwner',
									function(args){
										if(args.newValue === 'YES'){
											renderedFormControl.dataEntryApp.fieldValues.OwnerBuildingNumber = renderedFormControl.dataEntryApp.fieldValues.PhysicalBuildingNumber;
											renderedFormControl.dataEntryApp.fieldValues.OwnerStreet = renderedFormControl.dataEntryApp.fieldValues.PhysicalStreet;
											renderedFormControl.dataEntryApp.fieldValues.OwnerSuite = renderedFormControl.dataEntryApp.fieldValues.PhysicalSuite;
											renderedFormControl.dataEntryApp.fieldValues.OwnerCity = renderedFormControl.dataEntryApp.fieldValues.PhysicalCity;
										}
										else if(args.newValue === 'NO'){
											renderedFormControl.dataEntryApp.fieldValues.OwnerBuildingNumber = '';
											renderedFormControl.dataEntryApp.fieldValues.OwnerStreet = '';
											renderedFormControl.dataEntryApp.fieldValues.OwnerSuite = '';
											renderedFormControl.dataEntryApp.fieldValues.OwnerCity = '';
										}
									}
								);
							}
						}

						if(app.misc.isValueTrue(renderedFormControl.formConfig.allowFileUploads)){
							renderedFormControl.formConfig.fields.push(
								{
									type : 'file',
									properties : {
										group : 'File Uploads',
										id : 'fileUploaderControl',
										label : 'File'
									}
								}
							);
						}

						renderedFormControl.htmlTemplate = res;
						def.next();
					}
				);

				def.step(
					function(){
						setupFormDataObject(renderedFormControl);
						setupSubFormDataObject(renderedFormControl);
						def.next();
					}
				);

				def.step(
					function(){
						var renderedGroups = [],
							curColCount = 0,
							currentGroup = null,
							previousGroup = null,
							groupRendered = false;

						renderedFormControl.compiledHtml = renderedFormControl.htmlTemplate.compile(
							{
								formConfig : renderedFormControl.formConfig,
								helpers : renderedFormControl.formConfig.helper ? renderedFormControl.formConfig.helper :{
									renderField : function(field){
										var fieldHtml = (app.ui.fieldController[field.type] || app.ui.fieldController['default'])(field, renderedFormControl, jurisdiction),
											fieldWrapper = ``;

										if(!formConfig.columns || (formConfig.columns && formConfig.columns > 1 && (curColCount === 0 || groupRendered)) || field.type === 'file'){
											fieldWrapper += (curColCount > 0 && groupRendered)?`</div>`:`<div class="w-row">`;
											curColCount = 0;
										}
										fieldWrapper += `<div class="w-col w-col-` + (12 / (field.type === 'file' || field.properties.id === 'doCopySystemInfoToOwner'?1:(formConfig.columns || 1))) + `" style="` + ((formConfig.columns || 1 > 1)?`padding:5px;`:``) +  `">` + fieldHtml + `</div>`;

										if(!formConfig.columns || (formConfig.columns && formConfig.columns > 1 && (curColCount + 1 === formConfig.columns))){
											curColCount += `</div>`;
										}

										if(formConfig.columns && curColCount > formConfig.columns){
											curColCount = 0;
										}
										else if(formConfig.columns){
											++curColCount;
										}

										return fieldWrapper;
									},
									renderGroup : function(field){
										if (!previousGroup) previousGroup = field.properties.group;

										currentGroup = field.properties.group;

										if(field.properties.group && renderedGroups.indexOf(field.properties.group) === -1){
											groupRendered = false;
											renderedGroups.push(field.properties.group);

											let title = field.properties.group.split("~")[0],
												id = field.properties.group.replace(/[^A-Za-z0-9]/g, ''),
												returnGroupHtml = "";

											if (currentGroup !== previousGroup) returnGroupHtml = "</div>";

											return returnGroupHtml += `<div id="${id}">`+ `<div class="w-row"><div class="w-col w-col-12 group"><h4>${title}</h4></div></div>`.compile(field);
										} else {
											previousGroup = currentGroup;
											groupRendered = false;
										}
										//if __helperIsGrouping is true but field.properties.group is false
										//then we need to return an ending div
										if(field.properties.group) {
											window.__helperIsGrouping = true;
										} else {
											if(window.__helperIsGrouping) {
												window.__helperIsGrouping = false;
												previousGroup = currentGroup;
												return "</div>";
											}
											window.__helperIsGrouping = false;
										}
									},
									renderSubForm : function(subForm){
										var renderedSubForm = app.ui.subForm.render(subForm, renderedFormControl);

										listenersToApply.push(renderedSubForm.saveListener || function(){});

										return renderedSubForm.html;
									}
								}
							}
						);

						def.next();
					}
				);

				def.step(
					function(){
						$(renderedFormControl.formConfig.target).html(
							renderedFormControl.compiledHtml.replace(/\!\[/ig,'{{').replace(/\]\!/ig,'}}')
						);

						renderedFormControl.vueWatchers["fieldValues"] = {};
						renderedFormControl.formConfig.fields.forEach(function(field) {
							self.addFieldEventEmitterFunc(field, renderedFormControl, self.constructWatcherIDString(field));
						});

						let subForms = renderedFormControl.formConfig.subForms || [];

						subForms.forEach(function(subForm) {
							subForm.fields.forEach(function(field) {
								if (field) self.addFieldEventEmitterFunc(field, renderedFormControl, self.constructSubFormWatcherIDString(field, subForm));
							});
						});

						renderedFormControl.dataEntryApp = new Vue(
							{
								el: renderedFormControl.formConfig.target,
								data: renderedFormControl.vueData,
								methods : {
									getSubRecordValue : function(row, col){
										console.log(row,col);
										return row[col];
									},
									removeSubRecord : function(idx, data){
										if(confirm('Are you sure you want to remove this item?')){
											data.splice(idx, 1);
										}
									},
									removeFieldArrayValue : function(idx, fieldId){
										if(confirm('Are you sure you want to remove this item?')){
											renderedFormControl.dataEntryApp.fieldValues[fieldId].splice(idx, 1);
										}
									}
								},
								watch : renderedFormControl.vueWatchers
							}
						);

						setTimeout(function() {
							formConfig.fields.forEach(function(field) {
								self.addFieldEvents(field, formConfig.fields, renderedFormControl);
							});

							subForms.forEach(function(subForm) {
								subForm.fields.forEach(function(field) {
									self.addFieldEvents(field, subForm.fields, renderedFormControl);
								});
							});

							// copied from admin-portal ui.js
							const parseMinMaxDate = (string) => {
								// config string should be in the pattern of '-15D' for fifteen days ago, '3W' for 3 weeks ahead, etc
								// remove any spaces and split up the incoming config string
								const _string = string.replace(' ', '');
								const sign = _string.charAt(0);
								const offset = sign === '-' ? _string.slice(1, _string.length - 1) : _string.slice(0, _string.length - 1);

								// Moment uses upperCase 'M' to denote months in the below increment operation. Lowercase for (d)ay, (w)eek and (y)ear
								let unit = _string.slice(-1).toLowerCase().replace('m', 'M');

								// subtract from current date if first char in string is a minus sign, add if otherwise, then return the date object
								const limitDate = sign === '-' ? moment().subtract(offset, unit) : moment().add(offset, unit);
								return limitDate.toDate();
							};

							const getFieldConfig = (id) => {
								return renderedFormControl.formConfig.fields.find( f => f.properties.id === id);
							};

							/*
								NOTE:
									Apply a date picker to date fields.  Also make sure it sets appropriately the VueJS object appropriately
							*/
							$('.date-field:not(.reload-entry .date-field)').each( function() {
								const fieldConfig = getFieldConfig($(this).prop('id'));
								const fdEl = document.getElementById(fieldConfig.properties.id);

								// system specific date format, configured to be accepted by flatpickr
								const displayFormat = (fieldConfig.properties?.dateFormat || jurisdiction.hscSettings?.dateFormat || 'MM/DD/YYYY')
									.toUpperCase()
									.replace('MMM', 'M')
									.replace('MM', 'm')
									.replace('DD', 'd')
									.replace('YYYY', 'Y');

								// Parse config option string, return a dateobject for use in flatpickr 'minTime' and 'maxTime' options
								const parseMinMaxDate = (string) => {
									// config string should be in the pattern of '-15D' for fifteen days ago, '3W' for 3 weeks ahead, etc
									// remove any spaces and split up the incoming config string
									const _string = string.replace(' ', '');
									const sign = _string.charAt(0);
									const offset = sign === '-' ? _string.slice(1, _string.length - 1) : _string.slice(0, _string.length - 1);

									// Moment uses upperCase 'M' to denote months in the below increment operation. Lowercase for (d)ay, (w)eek and (y)ear
									let unit = _string.slice(-1).toLowerCase().replace('m', 'M');

									// subtract from current date if first char in string is a minus sign, add if otherwise, then return the date object
									const limitDate = sign === '-' ? moment().subtract(offset, unit) : moment().add(offset, unit);
									return limitDate.toDate();
								};

								const datePickerConfig = {
									enableTime: false,
									noCalendar: false,
									defaultDate: fdEl.value ? moment(fdEl.value, 'YYYY-MM-DD').toDate() : '', // default date read from input, empty string if not applicable
									allowInput: true,
									altInput: true,
									altFormat: displayFormat, // date format displayed to user... uses system date format or field date format 
									altInputClass: `alt-datePicker alt-${fdEl.id} form-control w-input`,
									appendTo: fdEl.parentNode,
									position() {},
									mode: fieldConfig.properties.dateSelectMode ? fieldConfig.properties.dateSelectMode.toLowerCase() : 'single',
									disable: [
										(date) => {
											// the disable prop wants an array of dates, init empty array to hold dates
											let disabledDates = [];

											// disabled weekends
											if (fieldConfig.properties.disableWeekends) {
											(date.getDay() === 0 || date.getDay() === 6) && disabledDates.push(date);
											}
											// return disabled date array if it exists, empty string if not
											return disabledDates.length ? disabledDates : '';
										},
									],
									minYear: parseMinMaxDate( fieldConfig.properties.minDate ?? "-5y" ).getFullYear(),
									maxYear: parseMinMaxDate( fieldConfig.properties.maxDate ?? "5y" ).getFullYear(),
									errorHandler(err) {
										/* Flatpickr yells at me when there is an empty input value
											- prevent console warning and flatpickr from setting input value as string "Invalid date" */
										if (err.message.includes('Invalid date')) {
										  	el.value = '';
										} else throw err;
									},
									onReady(a, b, fp) {
										fp.altInput.setAttribute('aria-label', fieldConfig.properties.label);

										if (fieldConfig.properties.placeholder !== undefined) {
										  	fp.altInput.setAttribute('placeholder', fieldConfig.properties.placeholder);
										} else {
										  	fp.altInput.setAttribute('placeholder', fieldConfig.properties.dateFormat || jurisdiction.hscSettings?.dateFormat);
										}
									},
									onChange(a, b, fp) {
										const value = b;
										const dataPath = fdEl.getAttribute('data-path').split('.');
										let obj = renderedFormControl.dataEntryApp;
										
										dataPath.forEach(
											function(path, index){
												if(dataPath.length === index + 1){
													obj[path] = value;
												}
												else {
													obj = obj[path];
												}
											}
										);
									},
									onDayCreate(dObj, dStr, fp, dayElem) {
									  if ($(dayElem).attr('tabindex') == -1) {
										$(dayElem).attr('tabindex', 0);
									  }
									},
									onOpen(selectedDates, dateStr, instance) {
									  instance.monthElements[0].setAttribute('tabindex', 0);
									  instance.currentYearElement.setAttribute('tabindex', 0);
									},
								  };

								// call flatpickr instance, attach it to the current field, pass in defined config options.
     					 		const instance = flatpickr(fdEl, datePickerConfig);

								// force flatpickr to recognize updates when user clicks away after using keyboard to input date
								// tabbing away from the input or pressing 'enter' automatically trigger the update
								$(`input.alt-${fdEl.id}`).on('blur', function () {
									instance.updateValue();
								});
							});

							/*
								NOTE:
									Apply a time picker to time fields.  Also make sure it sets appropriately the VueJS object appropriately
							*/
							$('.time-field:not(.reload-entry .time-field)').each( function() {
								const fieldConfig = getFieldConfig($(this).prop('id'));
								const fdEl = document.getElementById(fieldConfig.properties.id);

								const datePickerConfig = {
									enableTime: true,
									noCalendar: true,
									defaultDate: fdEl.value ? moment(fdEl.value, 'HH:mm A').toDate() : '', // default date read from input, empty string if not applicable
        							dateFormat: 'h:i K',
									time_24hr: fieldConfig.properties.twentyFourHr,
        							minuteIncrement: fieldConfig.properties.minuteIncrement ? fieldConfig.properties.minuteIncrement : 5,
									allowInput: true,
									altInput: true,
									altFormat: fieldConfig.properties.twentyFourHr ? 'H:i' : 'h:i K',
									altInputClass: `alt-timePicker alt-${fdEl.id} form-control w-input`,
									appendTo: fdEl.parentNode,
									position() {},
									minTime: fieldConfig.properties.minTime ? fieldConfig.properties.minTime : null,
        							maxTime: fieldConfig.properties.maxTime ? fieldConfig.properties.maxTime : null,
									onReady(a, b, fp) {
										fp.altInput.setAttribute('aria-label', fieldConfig.properties.label);

										if (fieldConfig.properties.placeholder !== undefined) {
										  	fp.altInput.setAttribute('placeholder', fieldConfig.properties.placeholder);
										} else {
										  	fp.altInput.setAttribute('placeholder', "00:00 AM");
										}
									},
									onChange(a, b, fp) {
										const value = b;
										const dataPath = fdEl.getAttribute('data-path').split('.');
										let obj = renderedFormControl.dataEntryApp;
										
										dataPath.forEach(
											function(path, index){
												if(dataPath.length === index + 1){
													obj[path] = value;
												}
												else {
													obj = obj[path];
												}
											}
										);
									},
									onOpen(selectedDates, dateStr, instance) {
									  const fields = ['hour', 'minute', 'am-pm'];
										for (const field of fields) {
											const $field = $(`.flatpickr-${field}:visible`);
											if ($field.attr('tabindex') == -1) {
												$field.attr('tabindex', 0);
											}
										}
										// Allow manual input but direct focus to the timepicker ui once the field is interacted with.
										if (fieldConfig.properties.timeFocus) {
											$(`input.numInput.flatpickr-hour`).focus();
										}
									},
								  };

								// call flatpickr instance, attach it to the current field, pass in defined config options.
     					 		const instance = flatpickr(fdEl, datePickerConfig);

								// force flatpickr to recognize updates when user clicks away after using keyboard to input date
								// tabbing away from the input or pressing 'enter' automatically trigger the update
								$(`input.alt-${fdEl.id}`).on('blur', function () {
									instance.updateValue();
								});
							});

							/*
								NOTE:
									Prevent a minus symbol from being added to the end of a number
							*/
							$('input[type=number]').on(
								'keydown',
								function(evt){
									if(this.value !== '' && evt.keyCode === 189) {
										return false;
									}
								}
							);

						},100);

						def.results(renderedFormControl).next();

						console.log('renderedFormControl',renderedFormControl);
					}
				);

				def.step(
					function(){
						def.next();

						listenersToApply.forEach(
							function(fn){
								fn();
							}
						);
					}
				);

			return def.begin();
		};

		/*
			Name: setupFormDataObject
			Use: PRIVATE.setupFormDataObject()
			Args: renderedFormControl Object - Full configuration for this data entry screen
			Description: Sets up the default values and data control object for VueJS for the standard data-entry screen fields
		*/
		function setupFormDataObject(renderedFormControl){
			renderedFormControl.formConfig.fields.forEach(
				function(field){
					var fieldValueObj = renderedFormControl.vueData.fieldValues;

					fieldValueObj[field.properties.id] = (function(){
						if(document.location.href.indexOf('/virginia') !== -1){
							var defaults = {
								ContractorCompanyName : '{entityName}',
								ContractorFirstName : '{firstName}',
								ContractorLastName : '{lastName}',
								ContractorEmailAddress : '{email}',
								ContractorPhone : '{cellNumber}',
								ContractorLicenceNumber : '{operatorLicenseNumber}'
							}
							return (defaults[field.properties.id] || '').compile(app.dataStore.get('session.info'));
						}
						else {
							return '';
						}
					})();

					/*
						NOTE:
							Checkboxes are stored as array values
					*/
					if(field.type === 'checkbox' || field.type === 'file'){
						fieldValueObj[field.properties.id] = [];
					}
					/*
						NOTE:
							Setup a unique data path to be used by VueJS
					*/
					field.dataPath = 'fieldValues.' + field.properties.id;

					if(field.default){
						fieldValueObj[field.properties.id] = field.default.toString().compile(
							{
								now: moment().format('YYYY-MM-DD'),
								nowTime: moment().format('h:mm A')
							}
						);
					}
				}
			);
		}

		/*
			Name: setupSubFormDataObject
			Use: PRIVATE.setupSubFormDataObject()
			Args: renderedFormControl Object - Full configuration for this data entry screen
			Description: Sets up the default values and data control object for VueJS for the sub forms and their fields
		*/
		function setupSubFormDataObject(renderedFormControl){
			(renderedFormControl.formConfig.subForms || []).forEach(
				function(subForm){
					try {
						/*
							NOTE:
								We setup a unique ID for this sub form for VueJS to point to and setup the metadata which will control this via VueJS
						*/
						subForm.id = 'F' + subForm.formID.replace(/-/ig,'');
						renderedFormControl.vueData.subForms[subForm.id] = {
							fieldValues : {},
							savedValues : []
						};

						/*
							NOTE:
								Loop through the fields on the sub form and setup the default data and path for them
						*/
						subForm.fields.forEach(
							function(field){
								if(field == null){
									return;
								}
								var fieldValueObj = renderedFormControl.vueData.subForms[subForm.id].fieldValues;

								fieldValueObj[field.properties.id] = '';

								/*
									NOTE:
										Checkboxes are stored as array values
								*/
								if(field.type === 'checkbox' || field.type === 'file'){
									fieldValueObj[field.properties.id] = [];
								}

								/*
									NOTE:
										Setup a unique data path to be used by VueJS
								*/
								field.dataPath = 'subForms.' + subForm.id + '.fieldValues.' + field.properties.id;

								if(field.default){
									fieldValueObj[field.properties.id] = field.default.compile(
										{
											now: moment().format('YYYY-MM-DD'),
											nowTime: moment().format('h:mm A')
										}
									);
								}
							}
						);
					}
					catch(e){
						console.log(e);
					}
				}
			);
		}

		return self
	}
);
